<template>
  <div class="widget">
    <div class="netpeak-footer">
      <div v-if="!subscriptionSent">
        <div
          class="text-center netpeak-footer__title"
          v-html="$t('netpeakFooter.title')"
        ></div>
        <div class="netpeak-footer__info">
          <div class="h6 text-center netpeak-footer__subtitle">
            {{ $t('netpeakFooter.subtitle') }}
          </div>
          <ul class="netpeak-footer__list">
            <li class="netpeak-footer__list-item">
              {{ $t('netpeakFooter.option1') }}
            </li>
            <li class="netpeak-footer__list-item">
              {{ $t('netpeakFooter.option2') }}
            </li>
            <li class="netpeak-footer__list-item">
              {{ $t('netpeakFooter.option3') }}
            </li>
            <li class="netpeak-footer__list-item">
              {{ $t('netpeakFooter.option4') }}
            </li>
          </ul>
        </div>
        <div
          class="text-center netpeak-footer__description"
          v-html="$t('netpeakFooter.description')"
        ></div>
        <NetpeakForm
          type="footer"
          :buttonText="$t('netpeakFooter.formButton')"
        />
      </div>
      <div v-else>
        <div
          class="text-center netpeak-footer__title"
          v-html="$t('netpeakModal.subscribedTitle')"
        ></div>
        <div
          class="text-center netpeak-footer__text"
          v-html="$t('netpeakModal.subscribedDescription')"
        ></div>
        <div
          class="text-center netpeak-footer__text"
          v-html="$t('netpeakModal.subscribedContent')"
        ></div>
        <div
          class="text-center netpeak-footer__notice"
          v-html="$t('netpeakModal.subscribedNotice')"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import NetpeakForm from '@/components/netpeak/NetpeakForm'
import { mapState } from 'vuex'

export default {
  name: 'NetpeakModal',
  components: {
    NetpeakForm,
  },
  computed: {
    ...mapState(['subscriptionSent']),
  },
}
</script>

<style>
.netpeak-footer {
  border: 1px solid #707070;
  border-radius: 25px;
  padding: 30px;
  max-width: 570px;
}
.netpeak-footer__title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 10px;
  line-height: 1;
  color: #fff;
}

.netpeak-footer .netpeak-form-input {
  background: #353535 !important;
}
.netpeak-footer .netpeak-form-button {
  background: #f7602b !important;
  font-weight: 700;
}
.netpeak-footer__subtitle {
  font-size: 15px;
}
.netpeak-footer__subtitle,
.netpeak-footer__description {
  font-size: 13px;
  color: #8f8f8f !important;
  line-height: 1;
}
.netpeak-footer__info {
  color: #fff;
  margin-bottom: 10px;
}
.netpeak-footer__list {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0;
  margin-right: -20px;
}
.netpeak-footer__description {
  margin-bottom: 15px;
  line-height: 1.5;
}
.netpeak-footer__list-item {
  font-size: 13px;
  font-weight: 700;
  /* width: 50%; */
  padding: 0 10px 0 0;
  margin: 0;
  list-style: none;
}
.netpeak-footer__list-item:before {
  width: 7px;
  height: 7px;
  background: #f76430 !important;
  margin-right: 5px;
}
.netpeak-modal__desc,
.netpeak-modal__text,
.netpeak-modal__notice {
  font-size: 15px;
}
.netpeak-modal__notice {
  margin-top: 15px;
}
.netpeak-footer__title span,
.netpeak-modal__notice span,
.netpeak-modal__desc span,
.netpeak-modal__text strong,
.netpeak-modal__text span {
  color: #f7602b;
}
</style>
